import React from 'react';

const Download = () => {
  return (
    <section
      className='py-20 bg-primary text-white'
      id='download'
    >
      <div className='container mx-auto px-4 max-w-4xl'>
        <div className='text-center mb-16'>
          <h2 className='text-3xl md:text-4xl font-bold mb-4'>
            How to Download <span className='text-accent'>TheChamps</span>
          </h2>
          <p className='text-lg text-text-submain max-w-2xl mx-auto'>
            Follow these simple steps to add TheChamps to your home screen and
            start your fitness journey
          </p>
        </div>

        <div className='grid grid-cols-1 md:grid-cols-2 gap-12'>
          {/* iOS Instructions */}
          <div className='bg-secondary rounded-xl p-8 border border-tertiary'>
            <div className='text-center mb-6'>
              <h3 className='text-2xl font-bold mb-4'>For iOS Users</h3>
              <ol className='text-left space-y-4 text-text-submain'>
                <li className='flex items-start gap-3'>
                  <span className='bg-accent text-black font-bold rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0'>
                    1
                  </span>
                  <span>Open Safari and go to thechamps.app</span>
                </li>
                <li className='flex items-start gap-3'>
                  <span className='bg-accent text-black font-bold rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0'>
                    2
                  </span>
                  <span>Tap the share icon at the bottom of the screen</span>
                </li>
                <li className='flex items-start gap-3'>
                  <span className='bg-accent text-black font-bold rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0'>
                    3
                  </span>
                  <span>Scroll down and select "Add to Home Screen"</span>
                </li>
                <li className='flex items-start gap-3'>
                  <span className='bg-accent text-black font-bold rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0'>
                    4
                  </span>
                  <span>Tap "Add" in the top right corner</span>
                </li>
              </ol>
            </div>
            <div className='flex justify-center'>
              <img
                src='https://static-resource.thechamps.app/img/tutorial/add-to-home-ios.png'
                alt='Add to Home Screen (iOS)'
                className='w-full max-w-[280px] rounded-lg shadow-lg'
              />
            </div>
          </div>

          {/* Android Instructions */}
          <div className='bg-secondary rounded-xl p-8 border border-tertiary'>
            <div className='text-center mb-6'>
              <h3 className='text-2xl font-bold mb-4'>For Android Users</h3>
              <ol className='text-left space-y-4 text-text-submain'>
                <li className='flex items-start gap-3'>
                  <span className='bg-accent text-black font-bold rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0'>
                    1
                  </span>
                  <span>Open Chrome and go to thechamps.app</span>
                </li>
                <li className='flex items-start gap-3'>
                  <span className='bg-accent text-black font-bold rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0'>
                    2
                  </span>
                  <span>Tap the three-dot menu in the top right corner</span>
                </li>
                <li className='flex items-start gap-3'>
                  <span className='bg-accent text-black font-bold rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0'>
                    3
                  </span>
                  <span>Select "Add to Home screen"</span>
                </li>
                <li className='flex items-start gap-3'>
                  <span className='bg-accent text-black font-bold rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0'>
                    4
                  </span>
                  <span>Tap "Add" to confirm</span>
                </li>
              </ol>
            </div>
            <div className='flex justify-center'>
              <img
                src='https://static-resource.thechamps.app/img/tutorial/add-to-home-aos.png'
                alt='Add to Home Screen (Android)'
                className='w-full max-w-[280px] rounded-lg shadow-lg'
              />
            </div>
          </div>
        </div>

        <div className='mt-12 text-center'>
          <a
            href='https://thechamps.app'
            target='_blank'
            rel='noopener noreferrer'
            className='inline-block bg-accent hover:bg-accentHover text-black font-bold py-3 px-8 rounded-full shadow-lg transition-all duration-300 transform hover:scale-105'
          >
            Open TheChamps
          </a>
        </div>
      </div>
    </section>
  );
};

export default Download;
